//$(document).ready(function () {
//    infoPrompt.init();
//});

// The three dots next to each record list
var infoPrompt = {};

infoPrompt.setup = function () {
    infoPrompt.checkCookie();
    infoPrompt.bind();
    infoPrompt.resize();
    infoPrompt.orientate();
};

infoPrompt.bind = function () {
    //infoPrompt.body.addEventListener('click', function (e) {
    //    infoPrompt.checkClick(e);
    //});

    infoPrompt.closeButton.addEventListener("click", function () {
        infoPrompt.addCookie();
        infoPrompt.deactivate();
    });
};

infoPrompt.resize = function () {
    window.addEventListener("resize", infoPrompt.changeHandler);
};

infoPrompt.orientate = function () {
    window.addEventListener("orientationchange", infoPrompt.changeHandler, false);
};

infoPrompt.changeHandler = function () {
    infoPrompt.checkPortrait();
};

//infoPrompt.checkClick = function (e) {

//    if (e.target.classList.contains(infoPrompt.containerClass)) {
//        infoPrompt.removeBodyListener();
//    } else if (e.target.parentNode.classList.contains(infoPrompt.containerClass)) {
//        infoPrompt.removeBodyListener();
//    } else {
//        infoPrompt.deactivate();
//    }
//};

infoPrompt.deactivate = function () {
    infoPrompt.hideMessage();
    infoPrompt.container.classList.add(infoPrompt.closedClass);
    infoPrompt.checkPortrait();

    //infoPrompt.removeBodyListener();
};

infoPrompt.checkCookie = function () {
    var cookie = logicjs.getCookie("LandscapeMessagePrompt");

    if (cookie) {
        infoPrompt.hideMessage();
        infoPrompt.checkPortrait();
    }
};

infoPrompt.hideMessage = function () {
    if (!infoPrompt.container.classList.contains(infoPrompt.hiddenClass)) infoPrompt.container.classList.add(infoPrompt.hiddenClass);
};

infoPrompt.showMessage = function () {
    if (infoPrompt.container.classList.contains(infoPrompt.hiddenClass)) infoPrompt.container.classList.remove(infoPrompt.hiddenClass);
};

infoPrompt.hideBar = function () {
    if (!infoPrompt.bar.classList.contains(infoPrompt.hiddenClass)) infoPrompt.bar.classList.add(infoPrompt.hiddenClass);
};

infoPrompt.showBar = function () {
    if (infoPrompt.bar.classList.contains(infoPrompt.hiddenClass)) infoPrompt.bar.classList.remove(infoPrompt.hiddenClass);
};

infoPrompt.addCookie = function () {
    logicjs.setCookie('LandscapeMessagePrompt', 'true', {
        expires: 0,
        path: '/'
    });
};

infoPrompt.detectPortrait = function () {
    if (window.innerHeight > window.innerWidth) {
        return true;
    } else if (window.matchMedia("(orientation: portrait)").matches) {
        return true
    } else {
        return false;
    }
};

infoPrompt.checkPortrait = function () {
    if (infoPrompt.detectPortrait()) {
        infoPrompt.showBar();
    } else {
        infoPrompt.hideBar();
    }
};

//infoPrompt.removeBodyListener = function () {
//    infoPrompt.body.removeEventListener('click', infoPrompt.checkClick, false);
//};

infoPrompt.init = function () {
    infoPrompt.containerClass = "c-info-prompt";
    infoPrompt.hiddenClass = "hidden";
    infoPrompt.closedClass = "closed";

    if (document.getElementsByClassName(infoPrompt.containerClass).length == 0) return;

    infoPrompt.container = document.getElementsByClassName(infoPrompt.containerClass)[0];
    if (infoPrompt.container.getElementsByClassName(infoPrompt.containerClass + "__button").length == 0) return;

    if (document.getElementsByClassName("c-info-bar--prompt-landscape").length == 0) return;
    if (document.getElementsByTagName("body").length == 0) return;

    infoPrompt.closeButton = infoPrompt.container.getElementsByClassName(infoPrompt.containerClass + "__button")[0];

    infoPrompt.bar = document.getElementsByClassName("c-info-bar--prompt-landscape")[0];

    infoPrompt.body = document.getElementsByTagName("body")[0];

    if (document.getElementsByClassName(infoPrompt.containerClass).length > 0) {
        infoPrompt.setup();
    }
};